/**
 * Code by Ruby - Convx - TL-3657
 * Variant A: Cart page (original - default live version)
 * Variant B: Cart drawer
 * set window.cartABTestVariant = 'B' for the test variant
 */
(function() {
  'use strict';
  
  if (typeof window.cartABTestVariant === 'undefined') {
    // Code by Ruby - Convx - TL-4217
    // window.cartABTestVariant = 'A';
    window.cartABTestVariant = 'B';
    // End of TL-4217
  }
  
  function setVariantAttribute() {
    if (document.body) {
      document.body.setAttribute('data-cart-ab-variant', window.cartABTestVariant);
      
      // if (window.location.search.includes('debug=abtest')) {
      //   console.log('Cart A/B Test Variant:', window.cartABTestVariant);
      // }
    }
  }
  
  function hideOriginalFreeShippingIfVariantB() {
    if (window.cartABTestVariant !== 'B') return;
    var originalFreeShipping = document.querySelector('.cart-drawer .free-shipping.free-shipping-original');
    if (originalFreeShipping) {
      originalFreeShipping.style.display = 'none';
    }
  }

  function openCartDrawer() {
    var container = document.getElementById('Cart-Drawer');
    if (!container) return;
    document.body.classList.add('open-cc');
    document.body.classList.add('open-cart');
    container.classList.add('active');
    container.focus();
    setTimeout(function() {
      var recs = container.querySelector('.product-recommendations--full');
      if (recs) recs.classList.add('active');
    });
    try {
      if (typeof dispatchCustomEvent === 'function') {
        dispatchCustomEvent('cart-drawer:open');
      }
    } catch (e) {}
  }

  function initViewCartOpensDrawer() {
    document.addEventListener('click', function(evt) {
      if (window.cartABTestVariant !== 'B') return;
      var btn = evt.target.closest('.product-atc-confirmation-view-cart-btn');
      if (!btn) return;
      evt.preventDefault();
      evt.stopPropagation();
      openCartDrawer();
    }, true);
  }

  function init() {
    setVariantAttribute();
    hideOriginalFreeShippingIfVariantB();
    initViewCartOpensDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('cart-drawer:open', hideOriginalFreeShippingIfVariantB);
  document.addEventListener('cart:item-added', hideOriginalFreeShippingIfVariantB);
  document.addEventListener('line-item:change:end', function () {
    // Defer so this runs after product.js renderContents() has replaced the cart drawer HTML. This specific for Quick View add
    setTimeout(hideOriginalFreeShippingIfVariantB, 0);
  });

  window.setCartABVariant = function(variant) {
    if (variant !== 'A' && variant !== 'B') {
      // console.error('Cart AB Test: Variant must be "A" or "B"');
      return;
    }
    window.cartABTestVariant = variant;
    if (document.body) {
      document.body.setAttribute('data-cart-ab-variant', variant);
    }
    // console.log('Cart AB Test variant set to:', variant);
  };
  
  if (document.body) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-cart-ab-variant') {
          const attrValue = document.body.getAttribute('data-cart-ab-variant');
          if (attrValue === 'A' || attrValue === 'B') {
            window.cartABTestVariant = attrValue;
          }
        }
      });
    });
    
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['data-cart-ab-variant']
    });
  } else {
    document.addEventListener('DOMContentLoaded', function() {
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'data-cart-ab-variant') {
            const attrValue = document.body.getAttribute('data-cart-ab-variant');
            if (attrValue === 'A' || attrValue === 'B') {
              window.cartABTestVariant = attrValue;
            }
          }
        });
      });
      
      if (document.body) {
        observer.observe(document.body, {
          attributes: true,
          attributeFilter: ['data-cart-ab-variant']
        });
      }
    });
  }
})();